import React from 'react';
import classnames from 'classnames';

import Link from 'sp-components/components/Link';

import { getStartedLink } from '../../util';

import './styles';

export default class ProductHero extends React.Component {
  render() {
    const { hero, pageType } = this.props;
    return (
      <div className={classnames('ProductHero', 'background', pageType)}>
        <div className="ui container p-t-2 p-b-2">
          <div className="ui grid middle aligned">
            <div className="six wide computer sixteen wide mobile column">
              <h2 className="hero-title">{hero.title}</h2>
              <h1 className="hero-description">{hero.description}</h1>
              <h4 className="hero-extra">{hero.extraContent}</h4>
              <Link to={getStartedLink(this.props.user)}>
                <button className="get-started inverted">{hero.button.text}</button>
              </Link>
            </div>
            <div className="six wide computer-only column">
              <img src={require(`../../assets/${hero.image}`)} />
            </div>
          </div>
        </div>
        <div className="ui divider" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ProductHero/index.jsx